import React from 'react';
import PickerItem from './PickerItem';
import { NoteIcon } from '../../../components/Icons';
export default function renderNoteItem(_ref) {
  var note = _ref.note,
      _ref$index = _ref.index,
      index = _ref$index === void 0 ? 0 : _ref$index,
      _ref$isSelected = _ref.isSelected,
      isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected,
      _ref$onSelectItem = _ref.onSelectItem,
      onSelectItem = _ref$onSelectItem === void 0 ? function () {} : _ref$onSelectItem,
      _ref$onClickItem = _ref.onClickItem,
      onClickItem = _ref$onClickItem === void 0 ? function () {} : _ref$onClickItem;
  return React.createElement(PickerItem, {
    "data-toolbar": "mention-picker-note-".concat(note.id),
    key: note.id,
    index: index,
    isSelected: isSelected,
    onMouseMove: onSelectItem,
    onClick: onClickItem,
    renderTitle: function renderTitle() {
      return React.createElement("span", null, note.title || 'Untitled');
    },
    renderSubtitle: function renderSubtitle() {
      return note.channelLabel;
    },
    renderIcon: function renderIcon(_ref2) {
      var width = _ref2.width;
      return React.createElement("div", {
        style: {
          width: width,
          height: width,
          lineHeight: '20px',
          padding: '0 6px'
        },
        className: "flexbox-no-grow flexbox-no-shrink center-text shade-30"
      }, React.createElement(NoteIcon, {
        size: "16"
      }));
    }
  });
}